import { render, staticRenderFns } from "./multiuserAcceptTemplate.vue?vue&type=template&id=29a25be1"
import script from "./multiuserAcceptTemplate.vue?vue&type=script&lang=js"
export * from "./multiuserAcceptTemplate.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports